import { useState, useEffect } from "react";
import { Pie } from '@ant-design/plots';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable'


function AuctionRep(){
  
    const [data, setData] = useState([]);

    useEffect(() => {
        asyncFetch();
      }, []);

    const asyncFetch=()=>{
        fetch(`${FetchVariable.Heroku}/auction/auction-vehicle-rep`)
        .then((response) => response.json())
        .then((json) => {
            setData(json)
        })
        .catch((error) => {
          console.log('fetch data failed', error);
        });
    }

    let styles = {
      marginTop: '50px',
      marginBottom: '50px'
  };

    const config = {
      // autoFit:true,
      height: 600,
      width: 600,
      appendPadding: 20,
        data,
        angleField: 'VehicleNumberFromEachAuction',
        colorField: 'AuctionName',
        radius: 0.95,
        label: {
            type: 'outer',
          content: '{percentage}',
        },
        legend: {
          layout: 'horizontal',
          position: 'bottom',
        },
        interactions: [
          {
            type: 'element-selected',
          },
          {
            type: 'element-active',
          },
        ],
      };

    return(
        <>
          <div className="container">
            <h1 className="text-center" style={styles}>Vehicles bought from Auction</h1>
            <Pie {...config} style={{marginTop:'100px'}}/>
          </div>
        </>
    )
}
export default AuctionRep